import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ReasonBehindLaunching from '../components/ReasonBehindLaunching'
import OurMission from '../components/OurMission'
import OurLocation from '../components/OurLocation'
import AboutUsComponent from '../components/AboutUsComponent'
import BreadCrumb from '../components/BreadCrumb'

import { Helmet } from "react-helmet";
import ScrollNavbar from '../components/ScrollNavbar'
 
const AboutPage = () => {
  // useEffect(()=>{
  //   document.title = "hello"
  // })
  return (
    <div>

<Helmet>
        <title>🐾 About FluffyTouch | Premium At-Home Pet Grooming Experts</title>
        <meta
          name="description"
          content="Discover FluffyTouch's story - certified pet groomers bringing stress-free, at-home grooming to your furry friends. Learn why 50,000+ pets love us!"
        />
      </Helmet>

      <ScrollNavbar/>
      
        <Navbar/>
        <BreadCrumb name="About Us"/>
        <AboutUsComponent/>
        <OurMission/>
        <ReasonBehindLaunching/>
        <OurLocation/>
        <Footer/>
    </div>
  )
}

export default AboutPage